import {
    Route,
    Routes,
} from 'react-router-dom';
import {RequirePermission} from '../../utils/RequirePermission.tsx';

import {IndexPage} from './pages/IndexPage';
import {EditPage} from './pages/EditPage.tsx';


export const ExecutionsLayout = () => {

    return (
        <Routes>
            <Route
                path={'/'}
                element={
                    <RequirePermission action='ListExecutions' redirectTo='/'>
                        <IndexPage/>
                    </RequirePermission>
                }
            />
            <Route
                path={':id'}
                element={
                    <RequirePermission action='ViewExecution' redirectTo='/executions'>
                        <EditPage/>
                    </RequirePermission>
                }
            />
        </Routes>
    );
};
